import { makeStyles, css } from '@conexasaude/hero'
import noise from '@/assets/noise.png'

const useStyles = makeStyles({
  container({ colors }) {
    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      vertical-align: center;
      position: relative;
      width: 100%;
      height: 100vh;
      padding: 0 16px;
      .logo-whitelabel {
        width: 160px;
      }
      .login-form {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: auto;
        @media screen and (max-width: 768px) {
          margin-top: 64px;
        }

        h3 {
          color: ${colors.neutral[400]};
          margin-bottom: 40px;
        }

        max-width: 360px;
        width: 100%;
        @media screen and (max-width: 768px) {
          width: 100%;
        }
      }
      .start-form {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-top: 42px;
        margin: auto;
        @media screen and (max-width: 768px) {
          margin-top: 64px;
        }
        @media screen and (max-height: 650px) {
          margin-top: 0px;
        }
        h1 {
          margin-bottom: 8px;
        }
        h3 {
          margin-bottom: 32px;
          color: ${colors.neutral[400]};
        }
        .button-login {
          height: 55px;
          margin-top: 6px;
        }
      }
      width: calc(100% - 16px);
      padding: 0;
      height: 80vh;
      @media screen and (max-height: 650px) {
        height: 100%;
      }
      .link-support {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 16px;
      }
      .link-support-start {
        margin-top: 16px;
      }
    `
  },

  containerIcon({ colors }) {
    return css`
      height: 100vh;
      flex-direction: row;
      display: flex;
      position: relative;
      .background {
        &__container {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          width: 100%;
          height: 100vh;
          &__icon {
            padding: 10px;
            z-index: 1;
          }
        }
        &__noise {
          position: absolute;
          background-image: url(${noise});
          //background-repeat: no-repeat;
          background-position: center;
          background-size: cover;
          height: 100vh;
          width: 100%;
        }
      }

      .link-login {
        display: flex;
        align-items: center;
        .divider {
          color: ${colors.secondary[500]};
        }
      }

      .footer-login {
        display: flex;
        align-items: center;
        text-align: center;
        font-size: 12px;
      }

      @media screen and (max-width: 768px) {
        align-items: center;
        height: auto;
        width: 100%;
        align-items: center;
        .login-form {
          margin-top: 60px;
        }
        .acess-link-login {
          display: flex;
          align-items: center;
          margin-left: 35px;
        }
        .icon-logo {
          width: 440px;
          height: 400px;
        }
        .start-form {
          flex-direction: column;
          margin-top: 80px;
        }

        .link-support-start {
          margin-top: 32px;
        }

        .link-login {
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
        .footer-login {
          margin-bottom: 25px;
          display: flex;
        }
      }
    `
  },
  containerBackground({ colors }) {
    return css`
      position: relative;
      width: 65%;
      height: 100vh;

      background: linear-gradient(
        -45deg,
        ${colors.primary[500]},
        ${colors.primary[900]}
      );
      background-size: 400% 400%;
      animation: gradient 10s ease infinite;

      @keyframes gradient {
        0% {
          background-position: 0% 50%;
        }
        50% {
          background-position: 100% 50%;
        }
        100% {
          background-position: 0% 50%;
        }
      }

      @media screen and (max-width: 768px) {
        width: 100%;
        height: 100vh;
      }
    `
  },
})

export default useStyles
